import React, { MutableRefObject, Ref } from 'react'
import '../Message.css'
import TextMessage from '../TextMessage'
import ImageMessage from '../ImageMessage'
import TemplateMessage from '../TemplateMessage/GenericTemplate/TemplateMessage'
import { NewMessagesLine } from '../NewMessagesLine'
import { ImageModalSettings, SettingsType } from 'models/SettingsType'
import { DeviceType } from 'models/DeviceType'
import { MessageType } from 'models/MessageType'
import { IframeSettingsType } from 'models/IframeSettingsType'
import WelcomeMessage from '../WelcomeMessage'

interface Props {
  classes: string
  message: any
  postMessage: (m: MessageType) => any
  parentURL: string
  showLogo: boolean
  showReply: boolean
  device: DeviceType
  settings: SettingsType
  timestamp?: Date
  setIframe: () => void
  iframeSettings: IframeSettingsType
  isEmpowerPre: boolean
  isEmpowerPost: boolean
  isPlacedInTheCenter?: boolean
  openIframe?: () => void
  openShare?: () => void
  messageBorder: string
  messageMargin?: string
  isMobile: boolean
  isPanoramaPost: boolean
  scrollToBottom: () => void
  isMaximized: boolean
  firstUnreadMessageId: string
  firstUnreadMessageRef: any
  avatarLogo: string,
  setDatePickerSettings: (prevState: (prevState) => any) => void
  isImageLoaded: boolean
  setIsImageLoaded: (prevState: boolean) => void,
  setIsImageZoomed: (props: boolean) => void
  isLastMessageInCurrentFlow: boolean
  setImageModalSettings: (props: ImageModalSettings) => void
  isFirstMessageInCurrentFlow: boolean
  isLoadingIframeData: boolean
  messagesRef: MutableRefObject<HTMLElement[]>
  messageIndex: number
  updateMessagesState: (id: string, value: string | number) => void
  passedOrSkippedFlowComponentsId: string[]
  setPassedOrSkippedFlowComponentsId: (id: string) => void
  textMessageRef: Ref<{ resetRating: () => void }>
}

const MessageBody: React.FC<Props> = ({
  classes,
  message,
  postMessage,
  parentURL,
  showLogo,
  showReply,
  device,
  settings,
  timestamp,
  setIframe,
  iframeSettings,
  isEmpowerPre,
  isEmpowerPost,
  isPlacedInTheCenter,
  openIframe,
  openShare,
  messageMargin,
  isMobile,
  isPanoramaPost,
  scrollToBottom,
  isMaximized,
  firstUnreadMessageId,
  firstUnreadMessageRef,
  avatarLogo,
  setDatePickerSettings,
  isImageLoaded,
  setIsImageLoaded,
  setIsImageZoomed,
  isLastMessageInCurrentFlow,
  setImageModalSettings,
  isFirstMessageInCurrentFlow,
  isLoadingIframeData,
  messagesRef,
  messageIndex,
  updateMessagesState,
  passedOrSkippedFlowComponentsId,
  setPassedOrSkippedFlowComponentsId,
  textMessageRef
}) => {

  return (
    <>
      {firstUnreadMessageId && message.id && firstUnreadMessageId === message.id && (
        <NewMessagesLine firstUnreadMessageRef={firstUnreadMessageRef} settings={settings} />
      )}

      {message.type === 'intro' && (
        <WelcomeMessage
          avatarLogo={avatarLogo}
          isFirstMessageInCurrentFlow={isFirstMessageInCurrentFlow}
          message={message}
        />
      )}
      {message.type === 'text' && (
        <TextMessage
          device={device}
          showLogo={showLogo}
          settings={settings}
          setIframe={setIframe}
          iframeSettings={iframeSettings}
          isEmpowerPre={isEmpowerPre}
          isEmpowerPost={isEmpowerPost}
          showReply={showReply}
          classesNames={classes}
          isPanoramaPost={isPanoramaPost}
          isMobile={isMobile}
          postMessage={postMessage}
          message={message}
          messageMargin={messageMargin}
          isMaximized={isMaximized}
          avatarLogo={avatarLogo}
          setDatePickerSettings={setDatePickerSettings}
          isLastMessageInCurrentFlow={isLastMessageInCurrentFlow}
          isImageLoaded={isImageLoaded}
          setIsImageLoaded={setIsImageLoaded}
          isLoadingIframeData={isLoadingIframeData}
          messagesRef={messagesRef}
          messageIndex={messageIndex}
          updateMessagesState={updateMessagesState}
          passedOrSkippedFlowComponentsId={passedOrSkippedFlowComponentsId}
          setPassedOrSkippedFlowComponentsId={setPassedOrSkippedFlowComponentsId}
          textMessageRef={textMessageRef}
        />
      )}
      {message.type === 'generic_template' && (
        <TemplateMessage
          style={classes}
          device={device}
          message={message}
          settings={settings}
          showLogo={showLogo}
          parentURL={parentURL}
          isMobile={isMobile}
          setIframe={setIframe}
          showReply={showReply}
          timestamp={timestamp}
          openIframe={openIframe}
          postMessage={postMessage}
          openShareScreen={openShare}
          scrollToBottom={scrollToBottom}
          isMaximized={isMaximized}
          isPanoramaPost={isPanoramaPost}
          avatarLogo={avatarLogo}
          setIsImageZoomed={setIsImageZoomed}
          isImageLoaded={isImageLoaded}
          setIsImageLoaded={setIsImageLoaded}
        />
      )}
      {message.type === 'attachment' && (
        <ImageMessage
          message={message}
          settings={settings}
          isMobile={isMobile}
          showLogo={showLogo}
          timestamp={timestamp}
          showReply={showReply}
          postMessage={postMessage}
          url={message.imageUrl}
          isPlacedInTheCenter={isPlacedInTheCenter}
          isMaximized={isMaximized}
          avatarLogo={avatarLogo}
          isImageLoaded={isImageLoaded}
          setIsImageLoaded={setIsImageLoaded}
          setImageModalSettings={setImageModalSettings}
          isLoadingIframeData={isLoadingIframeData}
        />
      )}
    </>
  )
}

export default MessageBody
